import apiClient from '@/api';
import { DeviceResponse } from '../types';
import { DEVICE_ROOT_API_URL } from '../constants';
import { SwapDeviceFormSchemaType } from './swap-device-schema';
import { SwapDeviceMetadata, SwapDevicerequest } from './types';

export function swapDevice(payload: SwapDevicerequest, deviceId: string) {
	const requestBody = new FormData();
	if (payload.file) {
		requestBody.append('file', payload.file);
	}
	requestBody.append('metadata', payload.metadata);
	return apiClient.post<DeviceResponse>(`${DEVICE_ROOT_API_URL}/${deviceId}/swap`, requestBody);
}

export function toSwapDeviceMetadata(data: SwapDeviceFormSchemaType): SwapDeviceMetadata {
	const parseNumber = (s: string) => parseInt(s, 10);

	const deviceValue = data.newDeviceId[0].value;
	const antennaValue = data.antennaTypeId[0].value;
	const panelValue = data.pvPanelTypeId[0].value;
	const poIdValue = data?.upload?.processObjectId || data?.fieldReport?.poId;

	return {
		newDeviceId: parseNumber(deviceValue),
		poId: poIdValue ? parseNumber(poIdValue) : null,
		antennaTypeId: parseNumber(antennaValue),
		pvPanelTypeId: parseNumber(panelValue),
		fileTitle: data.upload?.title,
		fileDescription: data.upload?.description,
		fieldReport: {
			...data.fieldReport,
			poId: poIdValue ? parseNumber(poIdValue) : null,
			performedAt: data.fieldReport?.performedAt?.toISOString() ?? null
		}
	};
}
